import styled from '@emotion/styled';

export const PlayIcon = styled.div({
    display: 'block',
    overflow: 'visible',
    ':before': {
        display: 'block',
        content: 'no-open-quote',
        width: '60px',
        height: '60px',
        borderRadius: '50%',
        backgroundColor: '#279BE4',
        marginTop: '-30px',
        marginLeft: '-30px',
    },
    ':after': {
        display: 'block',
        content: 'no-close-quote',
        width: 0,
        height: 0,
        border: '20px solid transparent',
        borderLeft: '30px solid #fff',
        marginTop: '-50px',
        marginLeft: '-10px',
    },
    ':hover': {
        ':before': {
            backgroundColor: '#0274BD',
        }
    }
});
